/*global YUI_config:true */
YUI_config = YUI_config || {};

/*
 * YUI Module configuration
 */
YUI_config.ModuleConfigurator = function (url, shouldCombine) {
    'use strict';

    this.shouldCombine = shouldCombine;

    function getBase(root) {
        let s = '',
            i = 0;
        if (url.lastIndexOf('/') < url.length - 1) {
            s = '/';
        }
        if (root.indexOf('/') === 0) {
            //if string starts with / the will drop the leading
            //'/' to avoid // in url which causes spring error
            i = 1;
        }
        return url + s + root.substring(i);
    }
    this.init = function (config) {
        const combine = this.shouldCombine || false;
        YUI_config.groups = YUI_config.groups || {};
        Object.keys(config || {}).forEach(function (groupName) {
            const group = config[groupName];
            YUI_config.groups[groupName] = {
                name: groupName,
                combine: group.combine === false ? false : combine,
                base: getBase(group.root),
                root: group.root,
                modules: group.modules
            };
        });
    };
    return this;
};
